(function documentControllerDefinition() {
    'use strict';

    angular.module('Document')
        .controller('DocumentVersionsController', [
            '$scope', '$translate', '$state', 'errorsExtend', '$stateParams', 'documentService', 'authExtend', 'storageService',
        function documentVersionsController($scope, $translate, $state, errors, $stateParams, documentService, authExtend, storageService) {

            $scope.ouName = authExtend.getOrganizationName();

            $scope.initDocumentFind = function () {
                if ($scope.urlFind) {
                    $state.go($scope.urlFind);
                }
            };

            $scope.cancel = function () {
                $state.goBack('mydocument-detail', { id: $scope.document.id });
            };

            $scope.load = function () {
                $scope.UserId = authExtend.getUserId();
                $scope.urlFind = storageService.getStateBackFind();
                $scope.hasBack = $state.hasPrevious();

                documentService.getVersion($stateParams.id).then(function (result) {
                    $scope.document = result;
                }, function (error) {
                    errors.showError(error);
                    $scope.cancel();
                });
            };

            $scope.load();

            $scope.view = function (document) {
                $state.go('document-version-detail', {
                    id: document.documentId,
                    nro: document.versionId
                });
            };

            $scope.MyView = function (document) {
                $state.go('mydocument-detail', {
                    id: document.documentId
                });
            };
        }
        ]);


})();